import { createSelector } from '@reduxjs/toolkit';

export const selectActiveOrderId = (state) => state.order.activeOrderId;
export const selectData = (state) => state.order.data;
export const selectError = (state) => state.order.error;
export const selectLoading = (state) => state.order.loading;
export const selectOrderUpdating = (state) => state.order.orderUpdating;
export const selectProductUpdating = (state) => state.order.productUpdating;

export const selectMainProduct = createSelector([selectData], (data) => {
  return data?.products?.find(({ code }) => code?.main) || {};
});
